import { Permiso } from './../../entities/Enums/permiso.enum';
import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENUITEMS.MENU.TEXT',
    permiso: Permiso.ConsultarTablero,
    isTitle: true,
  },
  {
    id: 2,
    label: 'MENUITEMS.DASHBOARDS.TEXT',
    permiso: Permiso.ConsultarTablero,
    icon: 'uil-home-alt',
    badge: {
      variant: 'primary',
      text: '01',
    },
    link: '/default',
  },
  {
    id: 3,
    label: 'MENUITEMS.ADMIN.TEXT',
    permiso: Permiso.ConsultarAdministracion,
    icon: 'uil-apps',
    subItems: [
      {
        id: 4,
        label: 'MENUITEMS.ADMIN.LIST.MODULES',
        permiso: Permiso.ConsultarModulos,
        link: '/administracion/modulos',
        parentId: 3,
      },
      {
        id: 5,
        label: 'MENUITEMS.ADMIN.LIST.PERMISSION',
        permiso: Permiso.ConsultarPermisos,
        link: '/administracion/permisos',
        parentId: 3,
      },
      {
        id: 9,
        label: 'MENUITEMS.ADMIN.LIST.LOGBOOK',
        permiso: Permiso.ConsultarBitacora,
        link: '/administracion/bitacora',
        parentId: 3,
      },
      {
        id: 10,
        label: 'MENUITEMS.ADMIN.LIST.METODOS',
        permiso: Permiso.ConsultarAdministracion,
        link: '/administracion/metodospago',
        parentId: 3,
      },
    ],
  },

  {
    id: 44,
    label: 'MENUITEMS.CLIENTES.TEXT',
    permiso: Permiso.ConsultarClientes,
    icon: 'uil-user-check',
    subItems: [
      {
        id: 18,
        label: 'MENUITEMS.CLIENTES.LIST.ADDUSER',
        permiso: Permiso.AgregarCliente,
        link: '/clientes/alta-cliente',
        parentId: 44,
      },
      {
        id: 19,
        label: 'MENUITEMS.CLIENTES.LIST.USERLIST',
        permiso: Permiso.ConsultarClientes,
        link: '/clientes/lista-clientes',
        parentId: 44,
      },
    ],
  },
  {
    id: 4,
    label: 'MENUITEMS.ENTITIES.TEXT',
    permiso: Permiso.ConsultarEntidades,
    icon: 'uil-store',
    subItems: [
      {
        id: 6,
        label: 'MENUITEMS.ENTITIES.LIST.STORE',
        permiso: Permiso.ConsultarCadenas,
        link: '/administracion/cadena',
        parentId: 4,
      },
      {
        id: 7,
        label: 'MENUITEMS.ENTITIES.LIST.BRANCH',
        permiso: Permiso.ConsultarSucursales,
        link: '/administracion/sucursal',
        parentId: 4,
      },
      {
        id: 8,
        label: 'MENUITEMS.ENTITIES.LIST.CASHREGISTER',
        permiso: Permiso.ConsultarCajas,
        link: '/administracion/caja',
        parentId: 4,
      }
    ]
  },
  {
    id: 5,
    label: 'MENUITEMS.USERS.TEXT',
    permiso: Permiso.ConsultarUsuarios,
    icon: 'uil-users-alt',
    subItems: [
      {
        id: 15,
        label: 'MENUITEMS.USERS.LIST.ADDUSER',
        permiso: Permiso.AgregarUsuario,
        link: '/usuarios/alta-usuario',
        parentId: 5,
      },
      {
        id: 16,
        label: 'MENUITEMS.USERS.LIST.USERLIST',
        permiso: Permiso.ConsultarUsuarios,
        link: '/usuarios/lista-usuarios',
        parentId: 5,
      },
    ],
  },
  {
    id: 52,
    label: 'Roles',
    permiso: Permiso.ConsultarRoles,
    icon: 'uil-shield-check',
    subItems: [
      {
        id: 15,
        label: 'Agregar Rol',
        permiso: Permiso.AgregarRol,
        link: '/roles/agregar-rol',
        parentId: 52,
      },
      {
        id: 16,
        label: 'Lista de Roles',
        permiso: Permiso.ConsultarRoles,
        link: '/roles/lista-roles',
        parentId: 52,
      },
    ],
  },
  {
    id: 6,
    label: 'Productos',
    permiso: Permiso.ConsultarProductos,
    icon: 'uil-gold',
    subItems: [
      {
        id: 19,
        label: 'Productos',
        permiso: Permiso.ConsultarProductos,
        link: '/productos',
        parentId: 6,
      },
      {
        id: 18,
        label: 'Agregar Producto',
        permiso: Permiso.AgregarProducto,
        link: '/productos/agregar-producto',
        parentId: 6,
      },
    ],
  },
  {
    id: 200,
    label: 'Inventario',
    icon: 'uil-archive-alt',
    subItems: [
      {
        id: 201,
        label: 'Compras',
        // permiso: Permiso.ConsultarCompras,
        link: '/productos/entradas',
        parentId: 200,
      },
      {
        id: 203,
        label: 'Salidas',
        // permiso: Permiso.ConsultarSalidas,
        link: '/productos/salidas',
        parentId: 200,
      },
      {
        id: 204,
        label: 'Ajustes',
        // permiso: Permiso.ConsultarAjustes,
        link: '/productos/ajustes',
        parentId: 200,
      },
      {
        id: 206,
        label: 'Traspasos',
        // permiso: Permiso.ConsultarTraspasos,
        link: '/productos/traspasos',
        parentId: 200,
      },
      {
        id: 208,
        label: 'Historial Traspasos',
        // permiso: Permiso.ConsultarHistorialTraspasos,
        link: '/productos/historial-traspasos',
        parentId: 200,
      },
      {
        id: 207,
        label: 'Kardex',
        // permiso: Permiso.ConsultarKardex,
        link: '/productos/kardex',
        parentId: 200,
      },
    ],
  },

  {
    id: 6,
    label: 'Reportes',
   // permiso: Permiso.ConsultarCierre,
    isTitle: true,
  },
  {
    id: 19,
    label: 'Cierre',
    link: '/reportes/cierre',
    icon: 'uil-file-check',
    //permiso: Permiso.ConsultarCierre,
    parentId: 44,
  },
  {
    id: 191,
    label: 'Venta Diaria',
    link: '/reportes/venta-diaria',
    icon: 'uil-chart-line',
   // permiso: Permiso.ConsultarCierre,
    parentId: 44,
  },

  {
    id: 60,
    label: 'Ajustes',
    isTitle: true,
  },
  {
    id: 61,
    label: 'Perfil de Usuario',
    icon: 'uil-chat-bubble-user',
    link: '/contacts/profile',
  },
  {
    id: 42,
    label: 'MENUITEMS.CIERRE.TEXT',
    isTitle: true,
  },
  {
    id: 43,
    label: 'MENUITEMS.CIERRESESION.TEXT',
    icon: 'uil-arrow-circle-right',
    link: '/account/login',
  },
];
